export const defaultShiftDashboardPageLimit = 100

export const mutationType = {
	setShiftDashboard: 'SET_SHIFT_DASHBOARD',
	setSelectedShiftRegistrations: 'SET_SELECTED_SHIFT_REGISTRATIONS',
	setLocationList: 'SET_LOCATION_LIST',
	setFilter: 'SET_FILTER'
}
